export enum PaymentSection {
  PLAN_SELECTION = 'plan-selection',
  PAYMENT_INFO = 'payment-info',
  PAYMENT_PROCESSING = 'payment-processing',
  THANK_YOU = 'thank-you',
  ERROR = 'error',
}
